import { useaxios } from "../../../utils/useaxios";
export default (from, to, barcode) => recaller => setrecaller => initDispatch => clear => settype => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/itemsellreport.php', { from, to, barcode }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setitemsellreport', payload: { sell_qty: res.sell_qty, sell_price: res.sell_price } });
            settype('itemsellreport');
            // setrecaller(recaller + 1);
        } else {
            // clear();
        }
        // setloading(false);
    });
}